import { jsx as _jsx } from "react/jsx-runtime";
import { Footer } from '@at/design-system-patterns';
import { useATTrackInteraction } from '@at/consumer-web-snowplow';
const useTrackSocialInteraction = () => {
    const fireTrackInteraction = useATTrackInteraction();
    return ({ socialName }) => {
        fireTrackInteraction({
            trackingLabel: `social-icon ${socialName}`,
        });
    };
};
const useTrackFooterLinkInteraction = () => {
    const fireTrackInteraction = useATTrackInteraction();
    return ({ labelIdentifier }) => {
        fireTrackInteraction({
            trackingLabel: labelIdentifier,
        });
    };
};
const useTrackAccordionInteraction = () => {
    const fireTrackInteraction = useATTrackInteraction();
    return ({ isExpanded, rowIndex }) => {
        fireTrackInteraction === null || fireTrackInteraction === void 0 ? void 0 : fireTrackInteraction({
            trackingLabel: `accordion footer: row-${rowIndex}  ${isExpanded ? 'expanded' : 'collapsed'} `,
        });
    };
};
export const ConnectedFooter = (props) => {
    const trackingCallbacks = {
        onSocialClick: useTrackSocialInteraction(),
        onFooterLinkClick: useTrackFooterLinkInteraction(),
        onFeedbackClick: useATTrackInteraction({
            trackingLabel: 'send feedback footer',
        }),
        onAccordionClick: useTrackAccordionInteraction(),
        onCompanyInfoClick: useATTrackInteraction({
            trackingLabel: 'company info footer',
        }),
    };
    return _jsx(Footer, Object.assign({ trackingCallbacks: trackingCallbacks }, props));
};
